import { Record } from "immutable";

export type AssigneeAggregatedStatsType = {
  totalStudyTime?: number;
  averageScore?: number;
  averageStudyTime?: number;
  averageSessionsCompleted?: number;
  averageBestScore?: number;
  averageWorstScore?: number;
  averageFirstScore?: number;
  averageLastScore?: number;
  sumQuestionMarks?: number;
  sumQuestionMarksTotal?: number;
};

export const defaultAssigneeAggregatedStats: AssigneeAggregatedStatsType = {
  totalStudyTime: undefined,
  averageScore: undefined,
  averageStudyTime: undefined,
  averageSessionsCompleted: undefined,
  averageBestScore: undefined,
  averageWorstScore: undefined,
  averageLastScore: undefined,
  averageFirstScore: undefined,
  sumQuestionMarks: undefined,
  sumQuestionMarksTotal: undefined
};

export default class AssigneeAggregatedStats extends Record(
  defaultAssigneeAggregatedStats
) {}
